document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.youtube-preview-videos').forEach(function(videosContainer) {
    const section = videosContainer.closest('.youtube-preview-section');
    const popup = section.querySelector('.youtube-preview-popup');
    const popupInner = popup.querySelector('.youtube-preview-popup-inner');
    const popupIframe = popup.querySelector('.youtube-preview-popup-iframe');
    const closeBtn = popup.querySelector('.youtube-preview-popup-close');

    function closePopup() {
      popup.style.display = 'none';
      popupIframe.innerHTML = '';
      document.body.classList.remove('youtube-preview-popup-open');
    }

    videosContainer.querySelectorAll('.youtube-preview-video-poster').forEach(function(poster) {
      poster.addEventListener('click', function() {
        const url = poster.getAttribute('data-youtube-url');
        if (!url) return;
        let videoId = '';
        // Extract YouTube video ID from URL
        const match = url.match(/[?&]v=([^&#]+)|youtu\.be\/([^&#]+)|youtube\.com\/embed\/([^&#?]+)/);
        if (match) {
          videoId = match[1] || match[2] || match[3];
        }
        if (!videoId) return;
        const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        popupIframe.innerHTML = `<iframe src="${embedUrl}" allowfullscreen allow="autoplay; encrypted-media"></iframe>`;
        popup.style.display = 'flex';
        document.body.classList.add('youtube-preview-popup-open');
        closeBtn.focus();
      });
    });

    closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', function(e) {
      if (e.target === popup) closePopup();
    });
    document.addEventListener('keydown', function(e) {
      if (popup.style.display === 'flex' && e.key === 'Escape') closePopup();
    });
  });
}); 